export default __webpack_public_path__ + "static/media/Mask of Red Ruin (nm).a8712dc1.jpg";